import { FieldValues } from "react-hook-form";
import { formLocales } from "src/locales/indexLocales";
import {
  ForgotPasswordProps,
  ResetPasswordProps,
} from "src/models/roleManagement.model";

import { cilLockLocked, cilUser } from "@coreui/icons";

export const forgotPasswordField: ForgotPasswordProps = {
  username: {
    id: "username",
    name: "username",
    placeHolder: formLocales.password.userName,
    icon: cilUser,
    rules: {
      required: formLocales.password.emailRequired,
      pattern: {
        value: /^\s*[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}\s*$/,
        message: formLocales.password.emailInvalid,
      },
    },
  },
};
export const resetPasswordField: ResetPasswordProps = {
  confirmPassword: {
    id: "confirmPassword",
    name: "confirmPassword",
    placeHolder: formLocales.role.confirmPassword,
    icon: cilLockLocked,
    type: "password",
    rules: {
      required: formLocales.role.confirmPasswordRequired,
      validate: (value: string, allValues: FieldValues) =>
        value === allValues.password
          ? true
          : formLocales.role.confirmPasswordMatch,
    },
  },
  password: {
    id: "password",
    name: "password",
    placeHolder: formLocales.role.password,
    icon: cilLockLocked,
    type: "password",
    rules: {
      required: formLocales.role.passwordRequired,
      pattern: {
        value:
          /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@#$%^&*!])[A-Za-z\d@#$%^&*!]{8,}$/,
        message: formLocales.role.passwordValid,
      },
    },
  },
};
